<div class="profile">
  <div class="profile__card">
    <a class="back-button" (click)="goBack()">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
      Back to All Users
    </a>
    <div class="profile__tabs">
      <div
        *ngFor="let tab of tabs"
        class="profile__tab"
        [class.profile__tab--active]="isActive(tab.path)"
        (click)="setActiveTab(tab.path)"
      >
        {{ tab.label }}
      </div>
    </div>

    <div class="profile__divider">
      <div class="profile__divider-line" [ngStyle]="{ width: activeTabWidth, left: activeTabLeft }"></div>
    </div>

    <div class="profile__content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
